import { jsx as _jsx } from "react/jsx-runtime";
const variantMapping = {
    header: "h1",
    subheader: "h2",
    title: "h3",
    subtitle: "h4",
    "section-heading": "span",
    "section-title": "span",
    "small-title": "span",
    text: "span",
    smallText: "span",
    box: "div",
};
const TypographyWrapper = ({ variant = "text", component, children, className, isDangerous, }) => {
    const props = {
        className,
        [isDangerous ? "dangerouslySetInnerHTML" : "children"]: isDangerous ? { __html: children } : children,
    };
    let Component;
    if (component) {
        Component = component;
    }
    else {
        Component = variantMapping[variant];
    }
    return _jsx(Component, { ...props });
};
export default TypographyWrapper;
